import { RuleRunService } from '@/api/services/RuleRunService';
import { SearchCollectionRuleRunDto } from '@/api';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const getMonitorRunsTool: ToolDefinition = {
  name: 'get_monitor_runs',
  description: 'Get monitor run history. Use for "last successful run", "when did it last succeed", or multiple runs. Returns paginated runs: id, status (SUCCESS, FAILED, REQUIRES_YOUR_ATTENTION, etc.), startDate (execution time, use for "when" - milliseconds), createdDate (record creation - milliseconds), endDate, result. Timestamps in milliseconds: divide by 1000 → seconds → DATE ONLY (no time/timezone). Example: 1763258928000 → Nov 16, 2025. Use status filter for successful/failed runs. Use sort for date ordering.',
  input_schema: {
    type: 'object',
    properties: {
      id: {
        type: 'string',
        description: 'Monitor UUID',
      },
      status: {
        type: 'array',
        description: 'Run status: SUCCESS, FAILED, REQUIRES_YOUR_ATTENTION, TECHNICAL_ERROR, PENDING, RUNNING',
        items: {
          type: 'string',
        },
      },
      page: {
        type: 'integer',
        description: 'Page number (default: 0)',
      },
      itemsPerPage: {
        type: 'integer',
        description: 'Items per page (default: 25)',
      },
      sort: {
        type: 'array',
        description: 'Sort: ["property,ASC"] or ["property,DESC"]. Example: ["createdDate,DESC"]',
        items: {
          type: 'string',
        },
      },
    },
    required: ['id'],
  },
};

/**
 * Execute the get_monitor_runs tool
 */
export async function executeGetMonitorRuns(params: any): Promise<SearchCollectionRuleRunDto | { error: string }> {
  try {
    // Ensure page is always >= 0 - axios interceptor decrements by 1
    let page = 1; // Default to 1 so interceptor makes it 0
    if (typeof params.page === 'number' && params.page >= 0) {
      page = params.page + 1; // Add 1 because interceptor will subtract 1
    }

    const requestParams: any = {
      id: params.id,
      page,
      itemsPerPage: params.itemsPerPage || 25,
    };

    if (params.status) {
      requestParams.status = params.status;
    }

    if (params.sort) {
      requestParams.sort = params.sort;
    }

    const result = await callWithContext('sifflet-ai-chat', () => RuleRunService.getSiffletRuleRuns(requestParams));

    return result;
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default getMonitorRunsTool;
